import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

// services
import { AeropuertoService } from '@despacho/aeropuerto.service';
import { MessageService } from '@shell/message.service';
import { PedidoService } from '@despacho/pedido.service';
import { Cuenta } from '@shared/models/cliente/Cuenta';
import { AerolineaDTO } from '@shared/models/despacho/AerolineaDTO';
import { AerolineaDestinoDTO } from '@shared/models/despacho/AerolineaDestinoDTO';
import { ErrorModel } from '@shared/models/ErrorModel';
import { Aeropuerto } from '@shared/models/despacho/Aeropuerto';
import { AerolineaEncabezadoDTO } from '@shared/models/despacho/AerolineaEncabezadoDTO';
import { CustomValidatorsService } from '@shared/validators/custom-validators.service';

export enum TipoConfiguracion {
  Destino,
  NroVuelo
}

@Component({
  selector: 'app-modal-destinos-tams',
  templateUrl: './modal-destinos-tams.component.html'
})
export class ModalDestinosTamsComponent implements OnInit {

  @Input() cuentas: Cuenta[];
  @Input() destinos: AerolineaDestinoDTO[];
  @Input() destinosOtrasAeroplantas: AerolineaDestinoDTO[];
  @Input() aerolineaSeleccionada: AerolineaEncabezadoDTO;
  @Input() codAeroplanta: string;
  @Input() nombreAeroplanta: string;

  listaAeropuertos: Aeropuerto[];

  destinoForm: UntypedFormGroup;
  guardandoDatos: boolean = false;
  cargandoAeropuertos: boolean = false;

  modal: NgbModal;
  fechaActual:Date = new Date();
  TipoConfiguracion = TipoConfiguracion;
  tipoConfiguracion: TipoConfiguracion = TipoConfiguracion.Destino;

  constructor(
    modal: NgbModal,
    private formBuilder: UntypedFormBuilder,
    private pedidoService: PedidoService,
    private messageService: MessageService,
    private aeropuertoService: AeropuertoService) {
      this.modal = modal;
    }

  ngOnInit(): void {
    this.crearFormulario();
    this.getAeropuertos();
  }

  crearFormulario() {
    this.destinoForm = this.formBuilder.group({
      codigoFormControl: ['', Validators.required],
      numeroVueloFormControl: [''],
      diaDesdeFormControl: [1, (Validators.required, Validators.min(1), Validators.max(31))],
      diaHastaFormControl: [31, (Validators.required, Validators.min(1), Validators.max(31))],
      cuentaFormControl: [null]
    });
  }

  onTipoConfiguracionChange(event) {
    this.tipoConfiguracion = event;
    this.handleValidators();
  }

  handleValidators() {
    this.codigoFormControl.setValue('');
    this.numeroVueloFormControl.setValue('');
    this.diaDesdeFormControl.setValue(1);
    this.diaHastaFormControl.setValue(31);

    this.destinoForm.controls.codigoFormControl.clearValidators();
    this.destinoForm.controls.numeroVueloFormControl.clearValidators();

    if (this.tipoConfiguracion == TipoConfiguracion.Destino) {
      this.destinoForm.controls.codigoFormControl.setValidators(
        [
          Validators.required,
          Validators.minLength(3)
        ]
      );
      this.destinoForm.controls.numeroVueloFormControl.setValidators(null);
    } else {
      this.destinoForm.controls.codigoFormControl.setValidators(null);
      this.destinoForm.controls.numeroVueloFormControl.setValidators(
        [
          Validators.required,
          Validators.minLength(3),
          CustomValidatorsService.flightNumberValidator
        ]
      );
    }

    this.destinoForm.controls.codigoFormControl.updateValueAndValidity();
    this.destinoForm.controls.numeroVueloFormControl.updateValueAndValidity();
  }

  /** servicios */

  getAeropuertos() {
    this.cargandoAeropuertos = true;
    this.aeropuertoService.getAeropuertos()
      .subscribe(res => {
        this.listaAeropuertos = res;
        this.cargandoAeropuertos = false;
      },()=>{
        this.cargandoAeropuertos = false;
      });
  }

  /** aeropuertos */

  formatterAeropuerto = (op: { codigoAeropuerto: string, nombre: string }) => {
    return (op != null && op.codigoAeropuerto != null) ? `${op.codigoAeropuerto} - ${op.nombre}` : "";
  }

  searchAeropuerto = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => this.listaAeropuertos == null || term.length < 2 || this.cargandoAeropuertos ? [] :
      this.listaAeropuertos.filter(op => this.containsString(this.codigoFormControl.value, op.codigoAeropuerto)).slice(0, 10))
  )

  containsString(searchValue: string, ...searchIn: string[]): boolean {
    const concat = searchIn.toString();
    return concat.toLowerCase().indexOf(searchValue.toLowerCase()) > -1
  }

  selectAeropuerto(event: any): void {
    this.codigoFormControl.setValue(event.item);
  }

  confirmAeropuerto() {
    if (typeof (this.codigoFormControl.value) === 'string') {
      this.messageService.showErrorMessage("El código destino ingresado no es válido.")
      this.codigoFormControl.setValue('');
    }
  }

  guardarDestinos() {

    if(!this.destinoForm.valid){
      this.messageService.showErrorLongMessage("Revise los campos incompletos");
      return;
    }
    const nuevoDiaDesde = Number(this.diaDesdeFormControl.value);
    const nuevoDiaHasta = Number(this.diaHastaFormControl.value);
    const nuevoCodigoAeropuerto = Number(this.tipoConfiguracion) === TipoConfiguracion.Destino
      ? this.codigoFormControl.value.codigoAeropuerto
      : this.numeroVueloFormControl.value;


    // Validar si el rango de días se superpone con algún destino existente
    const isSuperpuesto = this.destinos.some(destino => {
      const diaDesdeExistente = destino.diaDesde;
      const diaHastaExistente = destino.diaHasta;
      const codigoAeropuertoExistente = (destino.codigoAeropuerto !== null && destino.codigoAeropuerto !== undefined) ? destino.codigoAeropuerto : destino.numeroVuelo;
      return (nuevoCodigoAeropuerto.trim().toLowerCase() == codigoAeropuertoExistente.trim().toLowerCase()) &&
        ((nuevoDiaDesde >= diaDesdeExistente && nuevoDiaDesde <= diaHastaExistente) ||
        (nuevoDiaHasta >= diaDesdeExistente && nuevoDiaHasta <= diaHastaExistente) ||
        (nuevoDiaDesde <= diaDesdeExistente && nuevoDiaHasta >= diaHastaExistente));
    });

    if (isSuperpuesto) {
      this.messageService.showErrorMessage("El rango de días se superpone con un destino existente.");
      return;
    }
    if (nuevoDiaDesde > nuevoDiaHasta){
      this.messageService.showErrorMessage("El día desde no puede ser mayor al día hasta");
      return;
    }
    this.guardandoDatos = true;

    // armo el destino
    const destino = new AerolineaDestinoDTO;
    destino.codigoAeroplanta = this.codAeroplanta;
    destino.cuenta = this.cuentaFormControl.value;
    destino.codigoAeropuerto = (this.tipoConfiguracion == TipoConfiguracion.Destino) ? this.codigoFormControl.value.codigoAeropuerto : null;
    destino.numeroVuelo = (this.tipoConfiguracion == TipoConfiguracion.Destino) ? null : this.numeroVueloFormControl.value.toUpperCase();
    destino.diaDesde = Number(this.diaDesdeFormControl.value);
    destino.diaHasta = Number(this.diaHastaFormControl.value);
    this.destinos.push(destino);

    // armo aerolinea y le paso el destino nuevo + lo que ya tenia
    const aerolineaDTO = new AerolineaDTO;
    aerolineaDTO.id = this.aerolineaSeleccionada.id;
    aerolineaDTO.cuit = this.aerolineaSeleccionada.cuit;
    aerolineaDTO.razonSocial = this.aerolineaSeleccionada.razonSocial;
    aerolineaDTO.codigoAerolinea = this.aerolineaSeleccionada.codigoAerolinea;
    aerolineaDTO.cuentaNacional = this.aerolineaSeleccionada.cuentaNacional;
    aerolineaDTO.cuentaInternacional = this.aerolineaSeleccionada.cuentaInternacional;
    aerolineaDTO.destinos = this.destinosOtrasAeroplantas.concat(this.destinos);

    this.pedidoService.putAerolineas(this.aerolineaSeleccionada.id, aerolineaDTO)
    .subscribe(result => {
      console.log('Entro modificar ' + result);
      this.messageService.showSuccessMessage('Destino agregado con éxito.');
      this.guardandoDatos = false;
      this.modal.dismissAll();
    }, (err: ErrorModel) => {
      this.messageService.showErrorLongMessage(err.description);
      this.guardandoDatos = false;
      this.modal.dismissAll();
    });
  }

  /** getters */

  get codigoFormControl() {
    return this.destinoForm.get('codigoFormControl');
  }

  get numeroVueloFormControl() {
    return this.destinoForm.get('numeroVueloFormControl');
  }

  get diaDesdeFormControl() {
    return this.destinoForm.get('diaDesdeFormControl');
  }

  get diaHastaFormControl() {
    return this.destinoForm.get('diaHastaFormControl');
  }

  get cuentaFormControl() {
    return this.destinoForm.get('cuentaFormControl');
  }

}
